export function scrollToElement(element: HTMLElement, offset = 0, scrollbar?: string) {
  const y = element.offsetTop + offset;
  scroll(y, scrollbar);
}

export function scroll(value: number, scrollbar = '.page-container') {
  const container = document.querySelector(scrollbar)!;
  container?.scrollTo({ top: value, behavior: 'smooth' });
}
